module.exports = __webpack_public_path__ + "fonts/Ks_cVxiCiwUWVsFWFA3Bjn-_kf6ByYO6CLYdB4HQE-Y.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/content/fonts/roboto-font/Ks_cVxiCiwUWVsFWFA3Bjn-_kf6ByYO6CLYdB4HQE-Y.woff2
// module id = 330
// module chunks = 0